var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.531 20.7584C27.5191 18.5734 28.5073 16.9243 30.5077 15.7098C29.3884 14.1083 27.6977 13.2272 25.4651 13.0546C23.3516 12.8879 21.0417 14.2869 20.1963 14.2869C19.3033 14.2869 17.2553 13.1141 15.6478 13.1141C12.3258 13.1677 8.79541 15.7634 8.79541 21.0441C8.79541 22.6039 9.08118 24.2153 9.65271 25.8783C10.4148 28.0633 13.1653 33.4214 16.0348 33.3321C17.5351 33.2963 18.5948 32.2664 20.5475 32.2664C22.4407 32.2664 23.4231 33.3321 25.096 33.3321C27.9894 33.2904 30.4779 28.4205 31.2042 26.2296C27.3226 24.4019 27.531 20.8715 27.531 20.7584ZM24.1613 10.9828C25.7866 9.05384 25.6378 7.29757 25.5901 6.6665C24.1553 6.74985 22.4943 7.64287 21.5477 8.74426C20.5059 9.92305 19.8927 11.3816 20.0236 13.0248C21.5775 13.1439 22.9944 12.3461 24.1613 10.9828Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/AppleLogo.0e9dda96113ea1483d81bc7ffd09a8ac.svg";
export { ForwardRef as ReactComponent };